const Contact = () => {
    return (
        <div className="my-36 px-4 lg:px-36 flex flex-col lg:flex-row justify-between items-start">
            <div className="bg-white w-full max-w-lg">
                <p className="text-3xl font-bold mb-4 tracking-wide leading-normal">
                    <span className="underline underline-offset-8 decoration-4 decoration-[#E30022]">Con</span>tact Details
                </p>
                <p className="text-gray-700">
                    <strong>Organizing Secretary: Mr. Shantanu Bindewari</strong> 1st International Conference on Technology for Sustainable Development Goals 2025 (TECH4SDG-2K25)
                </p>
                <p className="text-gray-700 mt-2">
                    <strong>Location:</strong> Plot No.16-18, Iilm College Of Engineering & Technology, Knowledge Park II, Greater Noida, Uttar Pradesh 201306
                </p>
                <p className="text-gray-700 mt-2">
                    <strong>Email:</strong> 
                    <a href="mailto:tech4sdg@iilm.edu" className="text-blue-500 hover:underline">
                        tech4sdg@iilm.edu
                    </a>
                </p>
                <p className="text-gray-700 mt-2">
                    <strong>Contact:</strong> 
                    <a href="tel:(+91)88711 89169" className="text-blue-500 hover:underline">
                        (+91)88711 89169,
                        (+91)7988740031,
                        (+91)9910719256
                    </a>
                </p>
            </div>
            <div className="mb-4 lg:ml-8">
                <p className="font-bold text-3xl text-center mb-4">Venue</p>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.637177628496!2d77.4913143!3d28.460351700000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cc1e13dcbf0eb%3A0xfcf1c4d9749a78b4!2sIILM%20University%2C%20Greater%20Noida!5e0!3m2!1sen!2sin!4v1731074357699!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </div>
    );
};

export default Contact